<template>
	<v-card>
		<v-card-title>报表列编辑</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="12">
					<v-text-field
						label="字段名称*"
						name="name"
						placeholder=""
						v-model="form.name"
						:error-messages="errors.name"
						required
					></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field
						label="显示名称*"
						v-model="form.displayname"
						:error-messages="errors.displayname"
						required
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="6">
					<v-text-field
						label="排序值"
						type="number"
						v-model="form.sort"
						hint="默认排序值越大越靠后"
						persistent-hint
					></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field label="链接" v-model="form.link" hint=""></v-text-field>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<slot name="actions" v-bind:object="form"></slot>
		</v-card-actions>
	</v-card>
</template>

<script>
import { clone } from 'lodash-es'

export default {
	components: {},
	emits: ['update:value'],
	props: {
		value: { type: Object },
		errors: { type: Object, default: () => ({}) }
	},
	data: () => ({
		form: {},
		refs: {}
	}),
	computed: {},
	watch: {
		// form: {
		// 	handler: function (nv, oldVal) {
		// 		if (nv) {
		// 			this.$emit('update:value', this.form)
		// 		}
		// 	},
		// 	deep: true
		// }
	},
	mounted() {
		this.form = clone(this.value)
	},
	methods: {
		clear() {
			this.form = {}
		}
	}
}
</script>
<style></style>
